import { Box, colors, darken, lighten } from "@mui/material";
import styled, { css } from "styled-components";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";

const common_sectionBackground = (props: { colormatrix: TemplateColorObject }) => css`
	background-image: url("https://storage.googleapis.com/public_viteslink_storage/images/invitation01/inivitation01background01.png");
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	position: relative;
	.section_overlay {
		position: absolute;
		width: 100%;
		height: 100%;
		background: ${props.colormatrix.overlay};
		opacity: 0.3;
		z-index: 0;
	}
	.section_content {
		position: relative;
		top: 0;
		z-index: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 10px;
	}
`;

const common_btn = (props: { colormatrix: TemplateColorObject }) => css`
	background: ${props.colormatrix.button.background};
	color: ${props.colormatrix.button.text};
	border-radius: 25px;
	padding: 5px 15px;
	&.Mui-disabled {
		background: ${colors.grey[300]};
	}
`;

const common_partner_styles = css`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	.partner_img {
		height: 220px;
		max-width: 300px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 0 2px 2px #a4a4a4;
	}
	p {
		font-family: var(--roboto), sans-serif;
		font-size: 26px;
	}
`;

export const TemplateWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	overflow: hidden;

	.curve-container {
		position: absolute;
		z-index: 3;
		height: 60px;
		width: 100%;
		overflow: hidden;
		.curve {
			width: 100%;
			height: 60px;
			fill: ${props => props.colormatrix.main};
		}
	}

	.section_01 {
		${props => common_sectionBackground(props)};
		.section_content {
			height: 100vh;
			justify-content: unset;
		}
		.flower_01 {
			position: absolute;
			top: 0;
			left: 0;
			width: 170px;
			z-index: 2;
		}
		.flower_02 {
			position: absolute;
			width: 170px;
			right: 0;
			bottom: 0;
			z-index: 0;
		}
		.main_frame_wrapper {
			position: relative;
			width: 300px;
			height: 300px;
			//top: -90px;
			.wedding_of {
				position: absolute;
				font-size: 22px;
				z-index: 1;
				transform: rotate(347deg);
				right: 40px;
				top: -90px;
				font-family: var(--roboto), sans-serif;
			}

			.main_frame {
				position: absolute;
				z-index: 2;
				transform: rotate(347deg);
				width: 265px;
				max-height: 345px;
				left: 20px;
				top: -40px;
				background: #fff;
				padding: 10px;
			}
			.main_frame_envelope {
				position: absolute;
				left: -70px;
				bottom: -35px;
			}
			.main_frame_paper {
				position: absolute;
				right: -45px;
				top: -125px;
			}
			.main_frame_stamp {
				position: absolute;
				z-index: 2;
				right: 15px;
				top: -90px;
			}
		}
		.save_date_wrapper {
			position: absolute;
			top: 64vh;
			left: 15px;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			z-index: 1;
			.partners_text {
				font-family: var(--roboto), sans-serif;
				font-weight: bold;
				z-index: 1;
				font-size: 26px;
				color: ${props => props.colormatrix.font.primary};
			}
			.date {
				font-weight: bold;
				font-size: 24px;
				color: ${props => props.colormatrix.font.tertiary};
				font-family: var(--roboto), sans-serif;
			}
			.info {
				font-family: var(--roboto), sans-serif;
				font-size: 14px;
				font-weight: semiBold;
				margin: 3px;
			}
			button {
				${props => common_btn(props)}
				margin-top: 10px;
			}
		}
		& .no_images {
			height: 60vh;
			.save_date_wrapper {
				top: 25vh;
			}
		}
		.curve-container {
			transform: rotate(180deg);
			bottom: -1px;
		}
	}

	.section_02 {
		${props => common_sectionBackground(props)};
		.section_content {
			//justify-content: flex-start;
			padding-top: 120px;
		}

		.curve-container {
			top: 0;
		}
		.bismillah {
			width: 250px;
		}
		.flower_03 {
			position: absolute;
			top: 0;
			left: -15px;
			width: 170px;
			z-index: 2;
		}
		.main_intro {
			text-align: center;
			font-family: var(--roboto), sans-serif;
			font-size: 22px;
			color: ${lighten("#000", 0.2)};
			line-height: 1.3;
			padding: 10px;
		}
		.main_sub_intro {
			//font-family: var(--rochester), sans-serif;
			font-family: var(--roboto), sans-serif;
			font-size: 22px;
			color: ${lighten("#000", 0.2)};
		}
		.count_down_wrapper {
			margin-top: 30px;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.date {
				font-family: var(--roboto), sans-serif;
				font-size: 16px;
				letter-spacing: 1px;
				font-weight: 600;
				color: ${lighten("#000", 0.2)};
			}
			.counter_boxes_wrapper {
				display: flex;
				padding: 17px;
				.counter_box_wrapper {
					display: flex;
					flex-direction: column;
					margin: 10px;
					align-items: center;
					.counter_box {
						background: ${props => lighten(props.colormatrix.main, 0.4)};
						color: ${props => props.colormatrix.font.secondary};
						display: flex;
						justify-content: center;
						padding: 20px;
						border-radius: 5px;
						font-family: var(--roboto), sans-serif;
						font-size: 22px;
						min-width: 25px;
					}
					p {
						color: #000;
						margin-top: 10px;
						font-family: var(--roboto), sans-serif;
						font-size: 22px;
					}
				}
			}
		}
		.partners_container {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 30px;
			position: relative;
			.partner_01_wrapper {
				${common_partner_styles};
				padding-left: 35px;
				position: relative;
				.partners_ring {
					width: 110px;
					position: absolute;
					bottom: -4px;
					right: 22vw;
					z-index: 1;
				}
			}
			.partner_flower {
				width: 100px;
				margin: auto;
			}
			.partner_02_wrapper {
				${common_partner_styles};
				align-self: flex-end;
				padding-right: 35px;
				position: relative;
				margin-bottom: 20px;
				margin-top: 20px;
			}
		}
		.flower_04 {
			position: absolute;
			right: 0;
			bottom: 0;
			bottom: 100px;
			clip-path: inset(20% 0 35% 40%);
		}
	}
	.section_03 {
		background: ${props => darken(props.colormatrix.main, 0.2)};
		padding: 45px 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.bismillah {
			margin-bottom: 25px;
			width: 250px;
			direction: rtl;
		}
		.quran_start {
			font-family: var(--quran);
			font-size: 22px;
			color: #fff;
			text-align: center;
			font-weight: bold;
			margin-bottom: 25px;
			direction: rtl;
		}
		.quran {
			font-family: var(--quran);
			font-size: 22px;
			color: #fff;
			text-align: center;
			font-weight: bold;
			direction: rtl;
		}
		.quran_end {
			font-family: var(--quran);
			font-size: 22px;
			color: #fff;
			text-align: center;
			margin-top: 25px;
			font-weight: bold;
			direction: rtl;
		}
	}
	.section_04 {
		${props => common_sectionBackground(props)};

		.section_content {
			position: relative;
			padding: 10px;
			.flower_05 {
				position: absolute;
				top: 0;
				left: 0;
				width: 180px;
			}
			.section_title {
				font-family: var(--rochester), sans-serif;
				font-size: 32px;
				margin-top: 35px;
			}
			.love_story_wrapper {
				width: 100%;
				display: flex;
				justify-content: center;
				position: relative;
				margin: 30px 0;

				.story_image {
					max-width: 350px;
					background: #fff;
					border-radius: 10px;
				}
				.story_image_tag {
					position: absolute;
					top: -25px;
					left: -10px;
					z-index: 1;
				}
			}
			.stories {
				display: flex;
				flex-direction: column;
				margin-top: 30px;
				margin-bottom: 130px;
				min-width: 330px;
				.story {
					display: flex;
					flex-direction: column;
					align-items: center;
					padding: 10px 20px;
					p {
						font-family: var(--roboto), sans-serif;
						font-size: 20px;
						font-weight: 400;
						text-align: center;
					}
					hr {
						width: 100%;
						background-color: #000;
						margin: 10px 0;
					}
					p:first-child {
						margin: 10px 0;
					}
					p:last-child {
						color: ${lighten("#000", 0.4)};
					}
				}
			}

			.curve-container {
				transform: rotate(180deg);
				bottom: -12px;
				.curve {
					fill: #fff;
				}
			}
		}
		.flower_06 {
			position: absolute;
			bottom: 0;
			right: 0;
		}
	}
	.section_05 {
		display: flex;
		flex-flow: column;
		align-items: center;
		position: relative;
		margin-bottom: 25px;
		padding: 10px;

		.section_title {
			font-family: var(--rochester), sans-serif;
			font-size: 32px;
			margin-top: 35px;
		}
		.flower_07 {
			position: absolute;
			left: 0;
			top: 0;
		}
	}
	.section_06 {
		${props => common_sectionBackground(props)};
		.section_content {
			padding-top: 40px;
		}

		.section_title {
			font-family: var(--rochester), sans-serif;
			font-size: 32px;
		}

		.comment_text {
			font-family: var(--roboto), sans-serif;
			font-size: 22px;
			padding: 5px;
		}
		.comment_sub_text {
			font-family: var(--roboto), sans-serif;
			font-size: 14px;
			font-weight: 500;
			color: #000;
			text-align: center;
			padding: 0 30px;
		}
	}
	.section_07 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px 20px;
		.section_title {
			font-family: var(--rochester), sans-serif;
			font-size: 32px;
			margin-bottom: 20px;
			margin-top: 10px;
		}
		.section_sub_title {
			font-family: var(--roboto), sans-serif;
			font-size: 14px;
			font-weight: 500;
			color: ${lighten("#000", 0.5)};
			text-align: center;
			width: 90%;
		}
		.gift_input {
			border-radius: 5px;
			margin: 10px;
		}
		button {
			margin-top: 20px;
			border-radius: 20px;
			${props => common_btn(props)}
		}
	}

	.section_08 {
		${props => common_sectionBackground(props)};
		z-index: 1;
		.curved_edge {
			--c: 50px;
			height: 90px;
			aspect-ratio: 3/2;
			mask: radial-gradient(70% var(--c) at bottom, #0000 calc(100% - 2px), #000);
			background: #fff;
			width: 100%;
			position: absolute;
			top: -1px;
			z-index: 3;
		}
		.section_content {
			.flower_07 {
				position: absolute;
				top: 0;
				left: 0;
				width: 160px;
			}
			.section_title {
				font-family: var(--rochester), sans-serif;
				font-size: 30px;
				margin-top: 85px;
			}
			.location_text {
				font-family: var(--roboto), sans-serif;
				text-align: center;
				padding: 5px;
			}
			button {
				border-radius: 20px;
				margin: 15px;
				${props => common_btn(props)}
				padding: 10px 40px;
			}
			//.partner_03 {
			//	width: 240px;
			//	height: auto;
			//	margin: 10px 0;
			//}

			.partner_04_wrapper {
				border-radius: 20px;
				background: #fff;
				position: relative;
				box-shadow: 0 0 2px 2px #ebebeb;
				display: flex;
				.partner_04 {
					width: 220px;
					border-radius: 20px;
				}
			}
			.partners_text {
				font-family: var(--roboto), sans-serif;
				font-weight: bold;
				//z-index: 1;
				font-size: 26px;
			}
			.conclusion_text {
				font-family: var(--roboto), sans-serif;
				font-size: 16px;
				font-weight: semiBold;
				text-align: center;
				padding: 10px;
			}
		}
	}
	.section_09 {
		background: ${props => props.colormatrix.footer};
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		padding: 20px 0;

		p {
			color: #000;
			margin: 10px 0;
		}
		.social {
			cursor: pointer;
			text-decoration: none;
		}
	}
`;
